import styled from 'styled-components';
import { Button } from '@figure/frontlib-gui';
import { Typography } from 'shared/components';
import { useRedirect } from 'shared/hooks';

const StyledButton = styled(Button)`
  margin-top: 20px;
`;

const GenericDecline = () => {
  const { redirectToDashboard } = useRedirect();
  const handleDashboardClick = () => redirectToDashboard();

  return (
    <>
      <Typography.PageHeader>Thank you for your application.</Typography.PageHeader>
      <p>
        We’d love to serve you; however, you are not eligible for a loan at this time. Please visit
        your dashboard to view the adverse action notice, which provides the specific reasons for
        our decision.
      </p>

      <p>
        If you incorrectly entered information, please re-apply in your dashboard with the correct
        information.
      </p>

      <StyledButton large primary center onClick={handleDashboardClick}>
        Go to dashboard
      </StyledButton>
    </>
  );
};

export default GenericDecline;
